'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _assoc2 = require('ramda/src/assoc');

var _assoc3 = _interopRequireDefault(_assoc2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    background: ', ';\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n    ', '\n'], ['\n    position: relative;\n    background: ', ';\n    margin-top: 0px;\n    margin-bottom: 0px;\n\n    ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    ', '\n    h3 {\n        margin: 0;\n        font-size: 16px;\n        padding-left: 15px;\n        font-weight: 500;\n    }\n'], ['\n    ', '\n    h3 {\n        margin: 0;\n        font-size: 16px;\n        padding-left: 15px;\n        font-weight: 500;\n    }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: block;\n    float: none;\n    margin-top: 0;\n    position: absolute;\n    top: 8px;\n    right: 20px;\n    padding: 0;\n    text-align: right;\n'], ['\n    display: block;\n    float: none;\n    margin-top: 0;\n    position: absolute;\n    top: 8px;\n    right: 20px;\n    padding: 0;\n    text-align: right;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    cursor: pointer;\n    margin-left: 10px;\n    color: #e94f34 !important;\n    display: inline-block;\n    background: #fff;\n    border: #e94f34 1px solid;\n    border-radius: 50%;\n    display: inline-block;\n    height: 28px;\n    width: 28px;\n    line-height: 30px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: normal;\n    transition: all .3s ease-in-out;\n'], ['\n    cursor: pointer;\n    margin-left: 10px;\n    color: #e94f34 !important;\n    display: inline-block;\n    background: #fff;\n    border: #e94f34 1px solid;\n    border-radius: 50%;\n    display: inline-block;\n    height: 28px;\n    width: 28px;\n    line-height: 30px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: normal;\n    transition: all .3s ease-in-out;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    position: relative;\n    border: 0;\n    border-radius: 0;\n    background: ', ';\n    ', '\n    min-height: 60px;\n'], ['\n    position: relative;\n    border: 0;\n    border-radius: 0;\n    background: ', ';\n    ', '\n    min-height: 60px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    margin-top: 0px;\n'], ['\n    margin-top: 0px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    color: #dfe3e6;\n    font-weight: 500;\n    font-size: 28px;\n    line-height: 30px;\n    width: 40px;\n    text-align: center;\n'], ['\n    position: absolute;\n    top: 5px;\n    left: 5px;\n    color: #dfe3e6;\n    font-weight: 500;\n    font-size: 28px;\n    line-height: 30px;\n    width: 40px;\n    text-align: center;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    display: block;\n    float: none;\n    margin-top: 0;\n    position: absolute;\n    top: 4px;\n    right: 15px;\n    padding: 0;\n    text-align: right;\n'], ['\n    display: block;\n    float: none;\n    margin-top: 0;\n    position: absolute;\n    top: 4px;\n    right: 15px;\n    padding: 0;\n    text-align: right;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    cursor: ', ';\n    margin-left: 10px;\n    color: #2c3d4f !important;\n    font-size: 15px;\n    line-height: 22px;\n    display: ', ';\n'], ['\n    cursor: ', ';\n    margin-left: 10px;\n    color: #2c3d4f !important;\n    font-size: 15px;\n    line-height: 22px;\n    display: ', ';\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    display: ', ';\n'], ['\n    display: ', ';\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n    display: inline-block;\n    max-width: 380px;\n    min-width: 380px;\n'], ['\n    display: inline-block;\n    max-width: 380px;\n    min-width: 380px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactScroll = require('react-scroll');

var _fa = require('react-icons/fa');

var _reactBeautifulDnd = require('react-beautiful-dnd');

var _popconfirm = require('antd/lib/popconfirm');

var _popconfirm2 = _interopRequireDefault(_popconfirm);

var _dropdown = require('antd/lib/dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _menu = require('antd/lib/menu');

var _menu2 = _interopRequireDefault(_menu);

var _experiumPlayerHelpers = require('experium-player-helpers');

var _BlockTitles = require('../tableComponents/BlockTitles');

var _BlockTitles2 = _interopRequireDefault(_BlockTitles);

require('antd/lib/menu/style/index.css');

require('antd/lib/dropdown/style/index.css');

require('antd/lib/popover/style/index.css');

require('antd/lib/button/style/index.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Block = _styledComponents2.default.div(_templateObject, function (_ref) {
    var background = _ref.background,
        individualBackground = _ref.individualBackground;
    return background && !individualBackground ? '#f8f9f9' : '#fff';
}, function (_ref2) {
    var hiddenAll = _ref2.hiddenAll;
    return hiddenAll && '\n        .table-block-item {\n            display: none !important;\n\n            &.defaultInactive {\n                &.active {\n                    display: block !important;\n                }\n                &.active-inline {\n                    display: inline-block !important;\n                }\n            }\n        }\n    ';
});

var Header = _styledComponents2.default.div(_templateObject2, function (_ref3) {
    var hasButtons = _ref3.hasButtons,
        isSingle = _ref3.isSingle;
    return hasButtons ? '\n        position: relative;\n        padding-top: 5px;\n        min-height: 38px;\n    ' : '\n        position: absolute;\n        top: ' + (isSingle ? '1px' : '2px') + ';\n        left: 0px;\n        z-index: 1;\n    ';
});

var HeaderButtons = _styledComponents2.default.div(_templateObject3);

var HeaderButton = _styledComponents2.default.div(_templateObject4);

var ItemContainer = _styledComponents2.default.div(_templateObject5, function (_ref4) {
    var background = _ref4.background,
        individualBackground = _ref4.individualBackground;
    return background || individualBackground ? '#f8f9f9' : '#fff';
}, function (_ref5) {
    var isSingle = _ref5.isSingle,
        hasButtons = _ref5.hasButtons;
    return !isSingle ? '\n        padding: 0px;\n        margin: 0px;\n        padding-top: 20px;\n    ' : '\n        padding: 0.5rem 0;\n        ' + (hasButtons ? '' : 'padding-top: 20px;') + '\n    ';
});

var ItemWrapper = _react2.default.memo(_styledComponents2.default.div(_templateObject6));

var ItemNumber = _styledComponents2.default.div(_templateObject7);

var ItemButtons = _styledComponents2.default.div(_templateObject8);

var ItemButton = _styledComponents2.default.div(_templateObject9, function (_ref6) {
    var disabled = _ref6.disabled;
    return disabled ? 'not-allowed' : 'pointer';
}, function (_ref7) {
    var hiddenState = _ref7.hiddenState;
    return hiddenState ? 'none' : 'inline-block';
});

var ItemFields = _styledComponents2.default.div(_templateObject10, function (_ref8) {
    var hiddenState = _ref8.hiddenState;
    return hiddenState ? 'none' : 'block';
});

var DeleteContent = _styledComponents2.default.span(_templateObject11);

var TableBlockItem = function (_Component) {
    _inherits(TableBlockItem, _Component);

    function TableBlockItem(props) {
        _classCallCheck(this, TableBlockItem);

        var _this = _possibleConstructorReturn(this, (TableBlockItem.__proto__ || Object.getPrototypeOf(TableBlockItem)).call(this, props));

        _this.add = function () {
            _this.props.add(_this.props.index);
        };

        _this.addDown = function () {
            _this.props.add(_this.props.index + 1);
        };

        _this.remove = function () {
            if (_this.disableRemove()) {
                return;
            }

            _this.props.fields.remove(_this.props.index);
        };

        _this.disableRemove = function () {
            return _this.props.fields.length <= 1;
        };

        _this.itemRef = _react2.default.createRef();
        return _this;
    }

    _createClass(TableBlockItem, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            if (nextProps.length === this.props.length && nextProps.index === this.props.index && nextProps.hiddenName === this.props.hiddenName && nextProps.hidden === this.props.hidden && nextProps.isRevert === this.props.isRevert && nextProps.fieldName === this.props.fieldName && nextProps.name === this.props.name) {
                return false;
            }
            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                hidden = _props.hidden,
                hide = _props.hide,
                hiddenName = _props.hiddenName,
                index = _props.index,
                item = _props.item,
                name = _props.name,
                viewMode = _props.viewMode,
                isSingle = _props.isSingle,
                noSort = _props.noSort,
                isSave = _props.isSave,
                isRevert = _props.isRevert;

            var hiddenState = !!hidden;

            var deleteTitle = _react2.default.createElement(
                DeleteContent,
                null,
                _react2.default.createElement(
                    'b',
                    null,
                    _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteConfirm' })
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteDescription' })
            );

            var menuItems = _react2.default.createElement(
                _menu2.default,
                null,
                _react2.default.createElement(
                    _menu2.default.Item,
                    { key: 'top', onClick: this.add },
                    _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'addBlockTop' })
                ),
                _react2.default.createElement(
                    _menu2.default.Item,
                    { key: 'bottom', onClick: this.addDown },
                    _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'addBlockBottom' })
                )
            );

            return _react2.default.createElement(
                ItemContainer,
                { hasButtons: !isSingle && !noSort, innerRef: this.itemRef, isSingle: isSingle, background: item.background, individualBackground: item.individual_background },
                !noSort && (!isSingle || this.props.fields.length > 1) && _react2.default.createElement(
                    ItemNumber,
                    null,
                    isRevert ? index + 1 : this.props.fields.length - index
                ),
                noSort ? _react2.default.createElement(
                    ItemButtons,
                    null,
                    !viewMode && !isSingle && _react2.default.createElement(
                        _dropdown2.default,
                        { overlay: menuItems, placement: 'bottomCenter', getPopupContainer: function getPopupContainer() {
                                return _this2.itemRef.current;
                            } },
                        _react2.default.createElement(
                            ItemButton,
                            { onClick: this.add },
                            _react2.default.createElement(_fa.FaPlus, null)
                        )
                    ),
                    !viewMode && !isSingle && _react2.default.createElement(
                        _popconfirm2.default,
                        {
                            placement: 'leftTop',
                            title: deleteTitle,
                            okText: _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteOk' }),
                            cancelText: _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteCancel' }),
                            onConfirm: this.remove,
                            icon: null,
                            getPopupContainer: function getPopupContainer() {
                                return _this2.itemRef.current;
                            },
                            disabled: !isSave
                        },
                        _react2.default.createElement(
                            ItemButton,
                            { disabled: this.disableRemove(), onClick: isSave ? undefined : this.remove },
                            _react2.default.createElement(_fa.FaTimes, null)
                        )
                    )
                ) : _react2.default.createElement(
                    ItemButtons,
                    null,
                    !isSingle && _react2.default.createElement(
                        _react.Fragment,
                        null,
                        _react2.default.createElement(
                            ItemButton,
                            { className: (!hiddenState ? 'active-inline' : 'inactive-inline') + ' table-block-item defaultInactive', hiddenState: !hiddenState, onClick: function onClick() {
                                    return hide(hiddenName);
                                } },
                            _react2.default.createElement(_fa.FaChevronDown, null)
                        ),
                        _react2.default.createElement(
                            ItemButton,
                            { className: (hiddenState ? 'active-inline' : 'inactive-inline') + ' table-block-item defaultActive', hiddenState: hiddenState, onClick: function onClick() {
                                    return hide(hiddenName);
                                } },
                            _react2.default.createElement(_fa.FaChevronUp, null)
                        )
                    ),
                    !viewMode && !isSingle && _react2.default.createElement(
                        _dropdown2.default,
                        { overlay: menuItems, placement: 'bottomCenter', getPopupContainer: function getPopupContainer() {
                                return _this2.itemRef.current;
                            } },
                        _react2.default.createElement(
                            ItemButton,
                            { onClick: this.add },
                            _react2.default.createElement(_fa.FaPlus, null)
                        )
                    ),
                    !viewMode && !isSingle && _react2.default.createElement(
                        _popconfirm2.default,
                        {
                            placement: 'leftTop',
                            title: deleteTitle,
                            okText: _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteOk' }),
                            cancelText: _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, { id: 'deleteCancel' }),
                            onConfirm: this.remove,
                            icon: null,
                            getPopupContainer: function getPopupContainer() {
                                return _this2.itemRef.current;
                            },
                            disabled: !isSave
                        },
                        _react2.default.createElement(
                            ItemButton,
                            { disabled: this.disableRemove(), onClick: isSave ? undefined : this.remove },
                            _react2.default.createElement(_fa.FaTimes, null)
                        )
                    ),
                    !viewMode && !isSingle && _react2.default.createElement(
                        ItemButton,
                        null,
                        _react2.default.createElement(_fa.FaArrowsAltV, null)
                    )
                ),
                _react2.default.createElement(
                    ItemFields,
                    { className: (!hiddenState ? 'active' : 'inactive') + ' table-block-item defaultInactive', hiddenState: !hiddenState },
                    _react2.default.createElement(_BlockTitles2.default, { item: item, name: name, index: index })
                ),
                _react2.default.createElement(
                    ItemFields,
                    { className: (hiddenState ? 'active' : 'inactive') + ' table-block-item defaultActive', hiddenState: hiddenState },
                    _react2.default.createElement(
                        ItemWrapper,
                        null,
                        !index ? _react2.default.createElement(
                            _reactScroll.Element,
                            { name: name },
                            this.props.children
                        ) : this.props.children
                    )
                )
            );
        }
    }]);

    return TableBlockItem;
}(_react.Component);

TableBlockItem.propTypes = {
    children: _propTypes2.default.node,
    add: _propTypes2.default.func,
    hide: _propTypes2.default.func,
    isSingle: _propTypes2.default.bool,
    noSort: _propTypes2.default.bool,
    isSave: _propTypes2.default.bool,
    isRevert: _propTypes2.default.bool,
    viewMode: _propTypes2.default.bool,
    hidden: _propTypes2.default.bool,
    hiddenAll: _propTypes2.default.bool,
    name: _propTypes2.default.string,
    fieldName: _propTypes2.default.string,
    hiddenName: _propTypes2.default.string,
    index: _propTypes2.default.number,
    length: _propTypes2.default.number,
    item: _propTypes2.default.object,
    fields: _propTypes2.default.object
};

var TableBlock = function (_Component2) {
    _inherits(TableBlock, _Component2);

    function TableBlock(props) {
        _classCallCheck(this, TableBlock);

        var _this3 = _possibleConstructorReturn(this, (TableBlock.__proto__ || Object.getPrototypeOf(TableBlock)).call(this, props));

        _this3.hide = function (id) {
            _this3.setState(function (prev) {
                if (prev.hiddenAll) {
                    var hidden = {};
                    _this3.props.fields.map(function (name, index) {
                        return hidden[name + '-' + index] = true;
                    });
                    hidden[id] = false;

                    return {
                        hidden: hidden,
                        hiddenAll: false
                    };
                } else {
                    return {
                        hidden: (0, _assoc3.default)(id, !prev.hidden[id], prev.hidden),
                        hiddenAll: false
                    };
                }
            });
        };

        _this3.hideAll = function () {
            _this3.setState({
                hidden: {},
                hiddenAll: !_this3.state.hiddenAll
            });
        };

        _this3.resort = function () {
            _this3.props.fieldProps.input.onChange(!_this3.props.fieldProps.input.value);

            setTimeout(function () {
                _this3.props.fields.revert();
            }, 100);
        };

        _this3.add = function () {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            _this3.props.fields.new(index, {});
        };

        _this3.onDragEnd = function (result) {
            var fields = _this3.props.fields;
            var source = result.source,
                destination = result.destination;


            if (!destination) {
                return;
            }

            fields.move(source.index, destination.index);

            setTimeout(function () {
                _this3.props.fields.new(0, {});
                _this3.props.fields.remove(0);
            }, 100);
        };

        _this3.state = {
            hidden: {},
            hiddenAll: false,
            sorted: false
        };
        return _this3;
    }

    _createClass(TableBlock, [{
        key: 'render',
        value: function render() {
            var _this4 = this;

            var viewMode = this.props.viewMode;

            var isRevert = !!this.props.fieldProps.input.value;
            var isSingle = !!this.props.item.single;
            var noSort = this.props.item.sorting === false;
            var items = this.props.item.items || [];
            var header = items.find(function (item) {
                return item.type === 'h4';
            });
            var labelText = (0, _experiumPlayerHelpers.getText)(header || (0, _path3.default)(['items', 0], this.props.item), this.props.language);
            var isSave = this.props.item.dbsave === true || !!items.find(function (item) {
                return item.dbsave === true;
            });

            return _react2.default.createElement(
                Block,
                {
                    background: this.props.item.background,
                    hiddenAll: this.state.hiddenAll,
                    individualBackground: this.props.item.individual_background,
                    hasButtons: !isSingle && !noSort
                },
                _react2.default.createElement(
                    _reactScroll.Element,
                    { name: this.props.name },
                    _react2.default.createElement(
                        Header,
                        { hasButtons: !isSingle && !noSort, isSingle: isSingle },
                        _react2.default.createElement('h3', {
                            dangerouslySetInnerHTML: {
                                __html: labelText
                            }
                        }),
                        !isSingle && !noSort && _react2.default.createElement(
                            HeaderButtons,
                            null,
                            _react2.default.createElement(
                                HeaderButton,
                                { onClick: this.hideAll },
                                this.state.hiddenAll ? _react2.default.createElement(_fa.FaChevronDown, { size: '12px' }) : _react2.default.createElement(_fa.FaChevronUp, { size: '12px' })
                            ),
                            !viewMode && _react2.default.createElement(
                                HeaderButton,
                                { onClick: this.resort },
                                isRevert ? _react2.default.createElement(_fa.FaSortNumericUp, { size: '12px' }) : _react2.default.createElement(_fa.FaSortNumericDown, { size: '12px' })
                            )
                        )
                    ),
                    noSort ? _react2.default.createElement(
                        'div',
                        null,
                        this.props.fields.map(function (name, index) {
                            return _react2.default.createElement(
                                TableBlockItem,
                                {
                                    key: 'item-' + name + '-' + index,
                                    name: _this4.props.name,
                                    fields: _this4.props.fields,
                                    length: _this4.props.fields.length,
                                    index: index,
                                    item: _this4.props.item,
                                    isSingle: isSingle,
                                    noSort: noSort,
                                    isSave: isSave,
                                    viewMode: viewMode,
                                    hide: _this4.hide,
                                    add: _this4.add,
                                    hiddenName: name + '-' + index,
                                    hidden: _this4.state.hidden[name + '-' + index]
                                },
                                _this4.props.children(name, null, index)
                            );
                        })
                    ) : _react2.default.createElement(
                        _reactBeautifulDnd.DragDropContext,
                        { onDragEnd: this.onDragEnd },
                        _react2.default.createElement(
                            _reactBeautifulDnd.Droppable,
                            { droppableId: this.props.name },
                            function (provided) {
                                return _react2.default.createElement(
                                    'div',
                                    _extends({ ref: provided.innerRef }, provided.droppableProps),
                                    _this4.props.fields.map(function (name, index) {
                                        return _react2.default.createElement(
                                            _reactBeautifulDnd.Draggable,
                                            {
                                                key: 'drag-' + name + '-' + _this4.props.fields.length + '-' + index,
                                                draggableId: 'id-' + name + '-' + index,
                                                index: index,
                                                isDragDisabled: viewMode || isSingle
                                            },
                                            function (providedD) {
                                                return _react2.default.createElement(
                                                    'div',
                                                    _extends({
                                                        ref: providedD.innerRef
                                                    }, providedD.draggableProps, providedD.dragHandleProps, {
                                                        style: _extends({}, providedD.draggableProps.style)
                                                    }),
                                                    _react2.default.createElement(
                                                        TableBlockItem,
                                                        {
                                                            key: 'item-' + name + '-' + index,
                                                            name: _this4.props.name,
                                                            fieldName: name,
                                                            fields: _this4.props.fields,
                                                            index: index,
                                                            item: _this4.props.item,
                                                            isSingle: isSingle,
                                                            isSave: isSave,
                                                            viewMode: viewMode,
                                                            hide: _this4.hide,
                                                            add: _this4.add,
                                                            hiddenName: name + '-' + index,
                                                            hidden: _this4.state.hidden[name + '-' + index],
                                                            isRevert: isRevert
                                                        },
                                                        _this4.props.children(name, null, index)
                                                    )
                                                );
                                            }
                                        );
                                    }),
                                    provided.placeholder
                                );
                            }
                        )
                    )
                )
            );
        }
    }]);

    return TableBlock;
}(_react.Component);

TableBlock.propTypes = {
    name: _propTypes2.default.string,
    language: _propTypes2.default.string,
    viewMode: _propTypes2.default.bool,
    item: _propTypes2.default.object,
    fields: _propTypes2.default.object,
    fieldProps: _propTypes2.default.object,
    children: _propTypes2.default.func
};
exports.default = TableBlock;